"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserialize = exports.ObjectDeserializer = void 0;
const path_1 = require("./path");
const deserializationPath_1 = require("./deserializationPath");
const _1 = require(".");
class ObjectDeserializer {
    /**
     * Constructs an object deserializer. You should use convenient `deserialize` function instead of calling this
     * constructor directly.
     *
     * @param obj raw POJO to deserialize
     * @param initialPath initial path of this POJO
     */
    constructor(obj, initialPath) {
        this.obj = obj;
        this.path = initialPath || new deserializationPath_1.DeserializationPath();
        if (typeof obj !== 'object' || Array.isArray(obj))
            throw new _1.DeserializationError(this.path, 'Not an object');
    }
    followPath(obj, path) {
        let currentPath = this.path;
        for (const key of path) {
            if (obj === undefined || obj === null)
                return undefined;
            if (typeof obj !== 'object')
                throw new _1.DeserializationError(currentPath, `Not an object`);
            obj = obj[key];
            currentPath = currentPath.append([key]);
        }
        return obj;
    }
    /**
     * Try to get optional value by path.
     *
     * @param valuePath path to the value. Can be a string or path string delimited with a dot.
     */
    optional(valuePath) {
        const path = path_1.parsePath(valuePath);
        const v = this.followPath(this.obj, path);
        if (v === null || v === undefined)
            return undefined;
        return new _1.ValueWrapper(this.path.append(path), v);
    }
    /**
     * Get value by path. Throws if value is not exists.
     *
     * @param valuePath path to the value. Can be a string or path string delimited with a dot.
     * @throws DeserializationError
     */
    required(valuePath) {
        const path = path_1.parsePath(valuePath);
        const v = this.followPath(this.obj, path);
        if (v === null || v === undefined)
            throw new _1.DeserializationError(this.path.append(path), 'Value required');
        return new _1.ValueWrapper(this.path.append(path), v);
    }
}
exports.ObjectDeserializer = ObjectDeserializer;
/**
 * Convenient function to create ObjectDeserializer from POJO. POJO is a Plain Old Javascript Object.
 *
 * @param obj POJO to deserialize
 * @param mapper mapper function
 */
function deserialize(obj, mapper) {
    const deserializator = new ObjectDeserializer(obj);
    return mapper(deserializator);
}
exports.deserialize = deserialize;
